import axios from "axios";

let log = data => {
    axios.post("https://us-central1-of-applikation.cloudfunctions.net/log", {
        tool: "application",
        event: data
    });
};

export default log;



// WEBPACK FOOTER //
// ./src/splunk.js